import { useMemo } from 'react'
import { useTheme } from '@/shared/theme/ThemeContext'
import { getChartPalette } from './chartTheme'

/** The current theme and its chart palette, stable until the theme changes. */
export const useChartPalette = () => {
  const { theme } = useTheme()
  const palette = useMemo(() => getChartPalette(theme), [theme])
  return { theme, palette }
}
